/* eslint-disable camelcase */
import {
  Button,
  TextareaAutosize,
  Tooltip,
  Typography,
  makeStyles,
  IconButton,
  Divider,
  Select,
  MenuItem,
  ListItemText,
  Radio
} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import HelperUtils, {
  formMessageConversationActions
} from '@shared/utils/HelperUtils';
import React, {ReactElement, useEffect, useRef, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {Trans, useTranslation} from 'react-i18next';
import Loader from '@components/framework/loader/Loader';
import SendIcon from '@material-ui/icons/Send';
import moment from 'moment';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {
  getAMessage,
  getLastMessage,
  getMessageConversation,
  markAMessageAsRead,
  respondToMessage,
  startANewMessage,
  updateMessageCategoryType,
  updateMessageEventTypeStatus
} from '@shared/services/MessageService';
import RefreshIcon from '@material-ui/icons/Refresh';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Error';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import HelpIcon from '@material-ui/icons/Help';
import {
  AppSmsStatus,
  messageConversationActionKeys,
  messagesCategory,
  ReminderWorkFlowStatusTypes,
  SMS_DIRECTION
} from '@shared/constants/Mapping';
import {
  APP,
  // APP_PRIMARY_COLOR,
  DEFAULT_BLACK_COLOR,
  DEFAULT_GREEN_COLOR,
  DEFAULT_WHITE_COLOR,
  DEFAULT_YELLOW_COLOR
} from 'src/style/variable';
import './MessagesConversation.scss';

import {getAllCustomTemplates} from '@shared/services/CustomMessageServices';
import CustomSelectField from '@components/system/CustomSelectField/CustomSelectField';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ViewMediaFile from 'src/modules/shared/ViewMediaFile/ViewMediaFile';
import {getGuarantor} from '@shared/services/PatientsServices';
import MessagesAssignedUsers from './MessagesAssignedUsers/MessagesAssignedUsers';
import {useSelector} from 'react-redux';

import MoreVertIcon from '@material-ui/icons/MoreVert';

import CustomPopOver from '@components/system/CustomPopOver/CustomPopOver';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';
import {UserModelMapper} from '@shared/services/service-mappers/ModelMapper';
import MarkAsDoneDialog from '../MarkAsDoneDialog/MarkAsDoneDialog';
const AlertStyles = makeStyles(() => ({
  root: {
    '&:MuiDialog-paperWidthSm': {
      width: '20rem'
    },
    '&:.MuiDialog-paperFullWidth': {
      width: '20rem'
    }
  },

  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  mediaFiles: {
    display: 'flex',
    flexDirection: 'column'
  },
  menu: {
    maxHeight: '20rem',
    marginTop: '0.5rem',
    width: '23rem',

    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    }
  },

  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    }
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  text: {
    fontSize: '1.3rem'
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  Menu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  dropDownMainView: {
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    paddingLeft: '0.5rem',
    paddingBottom: '0.5rem'
  },
  dropDownInfo: {
    textAlign: 'left',
    lineHeight: '1rem',
    paddingTop: '0.5rem',
    fontSize: '1rem'
  },
  checkHeight: {
    // height: 'calc(100vh - 4rem)'
  },
  dropDownMainViewParent: {
    flex: '0 0 auto',
    backgroundColor: DEFAULT_WHITE_COLOR,
    zIndex: 99
  },
  MessageContent: {
    flex: '1 1 auto',
    overflowY: 'scroll',

    alignItems: 'center',
    justifyContent: 'center'
  },
  dialog: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  mainMenu: {
    maxHeight: '20rem',
    marginTop: '0.5rem',
    width: '23rem',
    marginLeft: '1rem',

    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  messageCategoryType: {
    color: DEFAULT_BLACK_COLOR,
    padding: '0.3rem',
    borderRadius: '0.5rem'
  },
  nonClinicalMessageBackgroundColor: {
    backgroundColor: DEFAULT_GREEN_COLOR
  },
  clinicalMessageBackgroundColor: {
    backgroundColor: DEFAULT_YELLOW_COLOR
  },
  messageCategorySection: {
    // paddingLeft: '0.5rem'
  },
  customPopOverStyles: {
    zIndex: 9
  }
}));
const FilterClinicStyles = makeStyles(() => ({
  root: {
    width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  clinicStyles: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.2rem',
    flexWrap: 'wrap'
  },
  labelStyle: {
    paddingRight: '0.5rem'
  },
  actionTypeLabel: {
    position: 'relative',
    bottom: '0.15rem'
  }
}));

function getMessageCategoryClass(category: string): string {
  let className = '';
  switch (category) {
    case messagesCategory.BILLING:
      className = 'non-clinical-message';
      break;
    case messagesCategory.CLINICAL:
      className = 'clinical-message';
      break;
  }
  return className;
}

const TooltipStyles = makeStyles(theme => ({
  arrow: {
    color: theme.palette.text.secondary
  },
  tooltip: {
    backgroundColor: theme.palette.text.secondary,
    fontSize: '1rem'
  }
}));

interface MessagesConversationProps {
  groupId: number;
  clinicId: number | any;
  guarantorId?: number | any;
  handleClose?: () => void;
  messageId: number;
  groupUsers: Array<UserModelMapper>;
  defaultEventType?: string | null;
}

const MessagesConversation = (
  props: MessagesConversationProps
): React.ReactElement => {
  // props de-structure
  const {
    groupId,
    clinicId,
    handleClose,
    messageId,
    guarantorId,
    groupUsers,
    defaultEventType
  } = props;
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const classes = AlertStyles();
  const ClinicClasses = FilterClinicStyles();
  const tooltipClasses = TooltipStyles();
  const [guarantorInfo, setGuarantorInfo]: any = useState([]);

  const [messages, setMessages] = useState<any[]>([]);
  const [isLoadingConversation, setIsLoadingConversation] = useState<boolean>(
    false
  );
  const [isSendingMessage, setIsSendingMessage] = useState<boolean>(false);
  const [isAllowSendMessage, setIsAllowSendMessage] = useState<boolean>(false);
  const [mediaKey, setMediaKey]: any = useState(-1);

  const [forceUpdate, setForceUpdate] = useState<number>(0);

  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const {control, getValues, setValue, reset} = useForm({
    mode: 'all'
  });

  const [templateList, setTemplateList] = useState<any[]>([]);

  const [messageText, setMessageText] = useState<string>('');
  const [selectedTemplate, setSelectedTemplate]: any = useState({});

  const clinicList: any = useSelector((state: any) => state.clinics.list || []);

  const patientShared = useSelector(
    (state: any) => state.clinics.patientShared
  );

  // KEPT COMMENTED FOR FUTURE REFERNECE
  // const getClinicLabel = (clinicIdParam: any) => {
  //   let clinicName = '';
  //   clinicList.map((item: any) => {
  //     if (item.id === clinicIdParam) {
  //       clinicName = item?.name;
  //     }
  //   });
  //   return clinicName;
  // };
  // // FIXME: clinicId is some times an array and sometimes an number need to update
  // const clinicName: any = getClinicLabel(
  //   Array.isArray(clinicId) ? clinicId?.[0] : clinicId
  // );

  const [selectedClinicId, setSelectedClinicId] = useState<{
    ClinicId: Array<any>;
    ClinicIdLabel: string;
  }>({
    // FIXME: clinicId is some times an array and sometimes an number need to update
    ClinicId: [],
    //  Array.isArray(clinicId) ? clinicId : [clinicId],
    ClinicIdLabel: ''
  });

  const [messageActionId, setMessageActionId]: any = useState(null);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [markAsDoneDialogState, setMarkAsDoneDialogState] = useState({
    isOpen: false,
    clinicGroupId: null as number | null,
    clinicId: null as number | null,
    messageId: null as number | null,
    notes: null as string | null
  });

  const renderDateSection = (message: any, index: number): ReactElement => {
    const messageDate = message.sms_sent_at || message.created_at;
    const previousMessageDate =
      messages[index - 1]?.sms_sent_at || messages[index - 1]?.created_at;
    if (index === 0) {
      return (
        <div className="date-wrap">
          <div className="date-wrap-child">
            {moment(messageDate).format('dddd, MMMM DD, YYYY')}
          </div>
        </div>
      );
    }
    if (
      messageDate &&
      messages[index - 1] &&
      previousMessageDate &&
      !moment(messageDate).isSame(moment(previousMessageDate), 'day')
    ) {
      return (
        <div className="date-wrap">
          <div className="date-wrap-child">
            {moment(messageDate).format('dddd, MMMM DD, YYYY')}
          </div>
        </div>
      );
    }
    return <div />;
  };
  // eslint-disable-next-line
  const getNewMessage = async (
    updatedMessageId: number,
    clinicIdParam: any = selectedClinicId?.ClinicId?.[0]
      ? selectedClinicId?.ClinicId?.[0]
      : clinicId
  ): Promise<any> => {
    try {
      const resp = await getAMessage(groupId, clinicIdParam, updatedMessageId);
      return resp?.data;
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) ||
          t('ERROR WHILE FETCHING INVOICE SERVICE DATA'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  // eslint-disable-next-line
  const refreshMessageStatus = async (messageId: number) => {
    try {
      const msg = await getNewMessage(
        messageId,
        selectedClinicId?.ClinicId?.[0]
      );
      if (msg) {
        setMessages(
          messages.map(el =>
            el.id === messageId ? Object.assign({}, el, msg) : el
          )
        );
      }
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) ||
          t('ERROR WHILE FETCHING INVOICE SERVICE DATA'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  const handleOpenMarkAsDoneDialog = (markAsDoneDialogProps: {
    clinicGroupId: number;
    clinicId: number;
    messageId: number;
    notes: string;
  }) => {
    setMarkAsDoneDialogState({
      isOpen: true,
      ...markAsDoneDialogProps
    });
  };

  const handleCloseMarkAsDoneDialog = (resp: 'confirm' | 'cancel') => {
    if (resp === 'confirm' && markAsDoneDialogState.messageId) {
      refreshMessageStatus(markAsDoneDialogState.messageId);
    }
    setMarkAsDoneDialogState({
      isOpen: false,
      clinicGroupId: null,
      clinicId: null,
      messageId: null,
      notes: null
    });
  };

  const renderRefresh = (status: string): ReactElement => {
    if (
      status &&
      status !== AppSmsStatus.SENT &&
      status !== AppSmsStatus.FAILED
    ) {
      return (
        <Tooltip
          title={`${t('INCOMING_SMS.CONVERSATION.REFRESH_MESSAGE_STATUS')}`}
          placement="bottom"
          arrow
          classes={tooltipClasses}>
          <RefreshIcon style={{color: APP.STATUS.DEFAULT}} fontSize={'small'} />
        </Tooltip>
      );
    }
    return <span />;
  };

  const renderNotificationStatusIcon = (
    status: any,
    error?: string
  ): ReactElement => {
    if (!status) {
      return <span />;
    } else if (status === AppSmsStatus.PENDING) {
      return (
        <Tooltip
          title={`${t('SMS_STATUSES.PENDING')}`}
          placement="bottom"
          arrow
          classes={tooltipClasses}>
          <HourglassFullIcon
            style={{color: APP.STATUS.WARNING}}
            fontSize={'small'}
          />
        </Tooltip>
      );
    } else if (status === AppSmsStatus.SENT) {
      return (
        <Tooltip
          title={`${t('SMS_STATUSES.SENT')}`}
          placement="bottom"
          arrow
          classes={tooltipClasses}>
          <CheckIcon style={{color: APP.STATUS.SUCCESS}} fontSize={'small'} />
        </Tooltip>
      );
    } else if (status === AppSmsStatus.FAILED) {
      return (
        <Tooltip
          title={`${error ? error : t('SMS_STATUSES.FAILED')}`}
          placement="bottom"
          arrow
          classes={tooltipClasses}>
          <ErrorIcon style={{color: APP.STATUS.ERROR}} fontSize={'small'} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          title={`${t('SMS_STATUSES.UNKNOWN')}`}
          placement="bottom"
          arrow
          classes={tooltipClasses}>
          <HelpIcon style={{color: APP.STATUS.DEFAULT}} fontSize={'small'} />
        </Tooltip>
      );
    }
  };

  const getSender = (message: any): string => {
    let name = '';
    if (message?.created_by < 0) {
      return t('APP.NAME');
    } else if (message?.sent_by) {
      name = HelperUtils.formCapitalizeFullName(
        message.sent_by?.first_name ?? '',
        message.sent_by.last_name ?? '',
        message.sent_by.middle_name ?? ''
      );
    } else {
      name = message.source;
    }
    return name;
  };

  const clearMessage = () => {
    reset({responseMessage: ''});
  };

  const scrollToBottom = (scrollPosition?: any) => {
    if (scrollPosition) {
      const my_element: any = document.getElementById(scrollPosition);
      my_element?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'end'
      });
    } else {
      messagesEndRef.current?.scrollIntoView({behavior: 'smooth'});
    }
  };

  const clearTemplate = () => {
    setMessageText('');
    setSelectedTemplate({});
    reset({responseMessage: ''});
  };

  const respond = async (clinicIdParam: number = clinicId): Promise<any> => {
    try {
      setIsSendingMessage(true);
      const responseMessage = getValues('responseMessage')?.trim();
      if (!responseMessage) {
        enqueueSnackbar(
          t('INCOMING_SMS.CONVERSATION.EMPTY_RESPOND_MESSAGE'),
          SnackBarConfig('e')
        );
        return;
      }

      // get last message to respond
      const lastMessage = messages[messages.length - 1];
      let resp;
      if ((!lastMessage || !lastMessage.id) && !clinicIdParam && !guarantorId) {
        enqueueSnackbar(
          t('INCOMING_SMS.CONVERSATION.NO_MESSAGE_TO_RESPOND'),
          SnackBarConfig('e')
        );
        return;
      } else if (!lastMessage && clinicIdParam && guarantorId) {
        // create new message conversation
        resp = await startANewMessage(
          groupId,
          clinicIdParam,
          guarantorId,
          responseMessage,
          selectedTemplate?.name_id,
          defaultEventType
        );
      } else {
        resp = await respondToMessage(
          groupId,
          clinicIdParam,
          lastMessage.id,
          responseMessage,
          selectedTemplate?.name_id,
          defaultEventType
        );
      }

      if (resp?.data?.id) {
        enqueueSnackbar(
          t('INCOMING_SMS.CONVERSATION.MESSAGE_QUEUED'),
          SnackBarConfig('s')
        );
        const msg = await getNewMessage(resp?.data?.id);
        if (msg) {
          setMessages([...messages, msg]);
        }
        // clear the menu dropdown when the message is queued to be sent
        clearTemplate();
      }

      clearMessage();
      scrollToBottom();
    } catch (error: any) {
      if (
        error !== null &&
        typeof error !== 'undefined' &&
        error.message !== null &&
        typeof error.message === 'string'
      ) {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      } else {
        enqueueSnackbar(
          t('INCOMING_SMS.CONVERSATION.FAILED_RESPONSE'),
          SnackBarConfig('e')
        );
      }
      throw error;
    } finally {
      setIsSendingMessage(false);
    }
  };
  // eslint-disable-next-line
  const loadConversations = async (
    newMessageId: number | any = messageId,
    clinicIdParam: any = clinicId
  ) => {
    try {
      setIsLoadingConversation(true);
      setIsAllowSendMessage(false);
      setMessages([]);

      if (!newMessageId && !clinicIdParam) {
        return;
      } else if (newMessageId) {
        const resp = await getMessageConversation(
          groupId,
          clinicIdParam,
          newMessageId
        );

        setIsAllowSendMessage(true);
        if (resp?.data?.rows?.length) {
          setMessages(resp.data.rows);
          // added because of conversation should load to get scroll div/element
          setTimeout(() => {
            scrollToBottom(`message-${newMessageId}`);
          }, 200);
        } else {
          setMessages([]);
        }
      } else if (clinicIdParam && guarantorId) {
        // show blank conversation with new message option to initiate a conversation
        setIsAllowSendMessage(true);
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    } finally {
      setIsLoadingConversation(false);
    }
  };
  // eslint-disable-next-line
  const openConversation = (messageId: number): void => {
    setIsLoadingConversation(true);
    loadConversations(messageId);
  };

  const getCustomMessageTemplates = async (clinicIdParam: number) => {
    try {
      const list = await getAllCustomTemplates(groupId, clinicIdParam);
      if (list?.data?.length > 0) {
        setTemplateList(list?.data);
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };
  const renderFullName = (name: any): string => {
    if (name) {
      return HelperUtils.commaSeparatedFullName(
        name.first_name,
        name.last_name
      );
    }
    return '';
  };

  const fetchGuarantorDetails = async () => {
    if (guarantorId && clinicId) {
      getGuarantor(groupId, guarantorId, clinicId)
        .then(async res => {
          if (res && res?.data) {
            setGuarantorInfo(res?.data?.guarantor || {});
          }
        })
        .catch(err => {
          enqueueSnackbar(
            (err && err.message) || t('PATIENTS.GET_PATIENT_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
        });
    }
  };

  const markGuarantorDetailEmpty = () => {
    setGuarantorInfo({});
  };

  /**
   * Failed case: When conversation is open with p1 practice and loading the conversation of different message of another clinic,
   *  state is holding previous practice id
   * Fix: update clinic to state when it is clinicId reference is change, because it always load the conversation with selected message clinic id.
   */

  useEffect(() => {
    setSelectedClinicId({
      ClinicId: Array.isArray(clinicId) ? clinicId : [clinicId],
      ClinicIdLabel: ''
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId]);

  useEffect(() => {
    if (guarantorId) {
      fetchGuarantorDetails();
    } else {
      markGuarantorDetailEmpty();
    }
    // eslint-disable-next-line
  }, [guarantorId]);

  useEffect(() => {
    // clear the menu dropdown and the content in text area field while switching between the messages
    clearTemplate();
    if (clinicId) {
      openConversation(messageId);
      getCustomMessageTemplates(clinicId);
    }

    setTimeout(() => {
      const idElement: any = document.getElementById('reference');
      idElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }, 500);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageId]);

  // Fetching the ClinicLabel using the clinicId
  useEffect(() => {
    let clinicName = '';
    clinicList.map((item: any) => {
      if (item.id === (Array.isArray(clinicId) ? clinicId?.[0] : clinicId)) {
        clinicName = item?.name;
      }
    });

    setSelectedClinicId((previousState: any) => {
      return {
        ...previousState,
        ClinicIdLabel: clinicName
      };
    });

    // eslint-disable-next-line
  }, []);

  const handleTemplateSelection = (template: any) => {
    setMessageText(template?.parsed_template);
    setSelectedTemplate(template);
    setValue('responseMessage', template?.parsed_template);
  };

  const renderCustomTemplateDropDown = (): ReactElement => {
    return (
      <div className={classes.mainMenu}>
        <Select
          data-test-id="pcl-payments-customTemplateDropDown"
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={
            selectedTemplate?.name_id
              ? selectedTemplate?.name_id
              : t('DUE_INVOICES.CUSTOM_MESSAGES.SELECT_PRE_DEFINED_MESSAGE')
          }
          variant="outlined"
          fullWidth={true}
          style={messageText ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic">
          <div className={classes.root}>
            <div className={classes.header}>
              <Typography className={classes.text}>
                {t('DUE_INVOICES.CUSTOM_MESSAGES.SELECT_TEMPLATE')}
              </Typography>
              <Button
                className={classes.clearAll}
                onClick={() => clearTemplate()}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={classes.menu}>
              {templateList.map((template: any) => {
                return (
                  <MenuItem
                    key={template.id}
                    value={template.name_id}
                    onClick={(): any => handleTemplateSelection(template)}>
                    <ListItemText
                      className={[classes.secondary, classes.primary].join(' ')}
                      primary={template.name_id}
                    />
                    <Radio checked={selectedTemplate?.id === template?.id} />
                  </MenuItem>
                );
              })}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const fetchLastMessageId = async (option: any) => {
    try {
      const lastMessageObj = await getLastMessage(
        groupId,
        option?.id,
        guarantorId
      );
      // passing last message id if present else empty string to handle the API call
      loadConversations(lastMessageObj.data?.id ?? '', option?.id);
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      // throw err;
    }
  };

  const clearClinicFilter = () => {
    setSelectedClinicId({
      ClinicId: [],
      ClinicIdLabel: ''
    });
  };
  const handleAccessOfClinics = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    // const acClinics: any = [];
    // setAccessClinicLabels(acClinics as string[]);
  };
  const clinicsMethod = (option: any) => {
    setSelectedClinicId({
      ClinicId: [option?.id],
      ClinicIdLabel: option?.name
    });
    setSelectedTemplate({});
    getCustomMessageTemplates(option?.id);
    // Calling the function by passing required params to fetch the last message id when clinic is selected from the messages conversation dropdown
    fetchLastMessageId(option);
  };
  // fetching the boolean value properly
  const getRadioCheckedOption = (clinic: any) => {
    const list: any = selectedClinicId?.ClinicId
      ? selectedClinicId?.ClinicId
      : [];

    if (!list || !list.length) return false;
    const indx = list.indexOf(clinic?.id);

    return indx > -1;
  };

  const renderClinicFilters = (): ReactElement => {
    return (
      <div style={{minWidth: '230px'}}>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={
            selectedClinicId?.ClinicId?.length
              ? selectedClinicId?.ClinicIdLabel
              : [t('DUE_INVOICES.PLACEHOLDERS.SELECT_CLINIC')]
          }
          variant="outlined"
          onChange={handleAccessOfClinics}
          fullWidth={true}
          style={selectedClinicId?.ClinicId?.length ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic">
          <div className={ClinicClasses.root}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem'}}>
                {t('PATIENTS.CLINICS')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={clearClinicFilter}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {clinicList.map((clinic: any) => (
                <MenuItem
                  key={clinic.id}
                  value={clinic.name}
                  onClick={(): void => clinicsMethod(clinic)}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic.name}
                    secondary={`${clinic.city}, ${clinic.country}`}
                  />
                  <Radio checked={getRadioCheckedOption(clinic)} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
        {/* </div> */}
      </div>
    );
  };

  const unmatchedOtpPhone = (): string => {
    if (guarantorId || guarantorInfo?.notification_phone) {
      return '';
    }
    const otpMessage = messages.find(
      (message: any) =>
        message?.event_type === 'voice_assistant_link' &&
        message?.direction === SMS_DIRECTION.OUTBOUND &&
        message?.destination
    );
    return otpMessage?.destination || '';
  };

  const renderDialogHeader = () => {
    // FIXME: To show clinic dropdown, use a prop to handle this not some concrete condition
    // Make the conversation usable and configurable with limited props
    const headerName = renderFullName(guarantorInfo);
    const headerPhone =
      guarantorInfo?.notification_phone || unmatchedOtpPhone();
    return (
      <div className={'custom-header'}>
        <div className="left-panel">
          <div>{t('INCOMING_SMS.CONVERSATION.TITLE')}</div>
          {headerName || headerPhone ? (
            <div className="subtitle">
              <>
                &nbsp; {'('}
                {headerName || ''}
                {headerName && headerPhone ? (
                  <strong>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</strong>
                ) : (
                  ''
                )}
                <strong>
                  {headerPhone ? (
                    <PhoneNumberFormatter value={headerPhone} />
                  ) : (
                    ''
                  )}
                </strong>
                {')'}
              </>
            </div>
          ) : (
            ''
          )}
        </div>
        <div>
          <div>
            {handleClose ? (
              <IconButton
                data-test-id="pcl-payments-closeConversationDialog"
                onClick={() => {
                  if (typeof handleClose === 'function') {
                    handleClose();
                  }
                }}>
                <Close />
              </IconButton>
            ) : patientShared ? (
              <div className={ClinicClasses.clinicStyles}>
                <div className={ClinicClasses.labelStyle}>
                  {t('ACTION_HISTORY.SELECT_CLINIC')}:{' '}
                </div>
                {renderClinicFilters()}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    );
  };
  const messageContentExists = (message: any) => {
    return (
      typeof message.body === 'string' ||
      (message.messages_media &&
        Array.isArray(message.messages_media) &&
        message.messages_media.length > 0)
    );
  };

  const updateEventTypeStatusMessageAction = async (
    clinicGroupId: number,
    clinicIdParam: number,
    messageIdParam: number,
    status: string | null
  ): Promise<any> => {
    try {
      const resp = await updateMessageEventTypeStatus(
        clinicGroupId,
        clinicIdParam,
        messageIdParam,
        status
      );
      if (resp && resp?.message) {
        enqueueSnackbar(resp.message, SnackBarConfig('s'));
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    }
  };

  const markMessageAsRead = async (
    clinicGroupId: number,
    clinicIdParam: number,
    messageObjId: number,
    isMarkRead: boolean
  ) => {
    try {
      const response = await markAMessageAsRead(
        clinicGroupId,
        clinicIdParam,
        messageObjId,
        isMarkRead
      );
      if (response && response?.message) {
        enqueueSnackbar(response?.message, SnackBarConfig('s'));
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const updateMessageInConversation = (
    key: string,
    value: any,
    index: number
  ) => {
    const allMessages: any = messages;
    const messageObject: any = allMessages[index];
    if (messageObject) {
      messageObject[key] = value;
    }
    allMessages[index] = messageObject;
    setMessages(allMessages);
    setForceUpdate(forceUpdate + 1);
  };

  const updateMessageStatus = async (
    message: any,
    index: any,
    messageStatus: string
  ) => {
    try {
      await updateEventTypeStatusMessageAction(
        message?.clinic_group_id,
        message?.clinic_id,
        message?.id,
        messageStatus
      );
      updateMessageInConversation('event_type_status', messageStatus, index);
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    }
  };

  const updateMessageCategory = async (
    message: any,
    index: number,
    message_category: string
  ) => {
    try {
      const response = await updateMessageCategoryType(
        message?.clinic_group_id,
        message?.clinic_id,
        message?.id,
        message_category
      );
      if (response && response?.message) {
        enqueueSnackbar(response?.message, SnackBarConfig('s'));
      }
      updateMessageInConversation('message_category', message_category, index);
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    }
  };

  const handleMessageAction = async (
    message: any,
    messageIndex: number,
    messageAction: any
  ) => {
    try {
      if (
        messageAction?.id === messageConversationActionKeys.MARK_AS_NOT_DONE
      ) {
        updateMessageStatus(
          message,
          messageIndex,
          ReminderWorkFlowStatusTypes.PENDING
        );
      }
      // do not show mark as done in options list
      // else if (
      //   messageAction?.id === messageConversationActionKeys.MARK_AS_DONE
      // ) {
      //   updateMessageStatus(
      //     message,
      //     messageIndex,
      //     ReminderWorkFlowStatusTypes.COMPLETED
      //   );
      // }
      else if (
        messageAction?.id === messageConversationActionKeys.NON_CLINICAL ||
        messageAction?.id === messageConversationActionKeys.CLINICAL
      ) {
        let messageCategory = messagesCategory.CLINICAL;
        if (messageAction?.id === messageConversationActionKeys.NON_CLINICAL) {
          messageCategory = messagesCategory.BILLING;
        }
        updateMessageCategory(message, messageIndex, messageCategory);
      } else if (
        messageAction?.id === messageConversationActionKeys.MARK_AS_NEW
      ) {
        if (message?.id) {
          await markMessageAsRead(
            message.clinic_group_id,
            message.clinic_id,
            message.id,
            false
          );
          updateMessageInConversation('is_read', false, messageIndex);
        }
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    } finally {
      setMessageActionId(null);
      setAnchorEl(null);
    }
  };

  return (
    <div
      className={
        !isLoadingConversation && messages.length === 0
          ? 'conversations-dialog-wrappers'
          : [classes.checkHeight, 'conversations-dialog-wrappers'].join(' ')
      }>
      <div className="conversations-dialog-headers">
        {<Typography>{renderDialogHeader()}</Typography>}
      </div>
      <Typography className={classes.MessageContent}>
        {isLoadingConversation && (
          <div className="loader-wrap">
            <Loader />
          </div>
        )}
        {!isLoadingConversation && (
          <div className={'messages-wrapper'} id="reference">
            {messages.length > 0 &&
              messages.map((message, index) => {
                return (
                  <div
                    key={`${message.id}-${message.created_at}`}
                    id={`message-${message.id}`}>
                    {messageContentExists(message) &&
                      renderDateSection(message, index)}
                    {messageContentExists(message) && (
                      <div
                        style={{paddingRight: '1rem'}}
                        className={[
                          'each-message',
                          message.sent_by ||
                          message.direction === SMS_DIRECTION.OUTBOUND
                            ? 'self-message'
                            : 'other-message'
                        ].join(' ')}>
                        <div className="message-wrap">
                          <div className="message-body-wrap">
                            {message.direction === SMS_DIRECTION.OUTBOUND ? (
                              message.body && (
                                <div
                                  className={[
                                    'body',
                                    message.archived ? 'archive-body' : ''
                                  ].join(' ')}>
                                  {message.body && (
                                    <div className="body-content">
                                      {message.body}
                                    </div>
                                  )}
                                </div>
                              )
                            ) : (
                              <div
                                className={
                                  message?.messages_media ? 'media-body' : ''
                                }>
                                <div
                                  className={['body', classes.mediaFiles].join(
                                    ' '
                                  )}>
                                  <div className={'message-category-section'}>
                                    {/* showing message category only for clinical messages */}
                                    {message?.message_category ===
                                      messagesCategory.CLINICAL && (
                                      <div
                                        className={[
                                          'message-category-chip',
                                          getMessageCategoryClass(
                                            message?.message_category
                                          )
                                        ].join(' ')}>
                                        {message?.message_category ===
                                          messagesCategory.CLINICAL &&
                                          t(
                                            'INCOMING_SMS.CONVERSATION.CLINICAL_MESSAGE'
                                          )}
                                      </div>
                                    )}
                                    <Tooltip
                                      title={`${t('COMMON.ACTIONS')}`}
                                      classes={tooltipClasses}
                                      placement="top">
                                      <IconButton
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        color="inherit"
                                        size="small"
                                        onClick={(event: any) => {
                                          setAnchorEl(event.currentTarget);
                                          setMessageActionId(message?.id);
                                          event.stopPropagation();
                                        }}>
                                        <MoreVertIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {messageActionId === message?.id && (
                                      // Added enablePortal prop to make the custom popover to appear on top of body
                                      <div
                                        className={classes.customPopOverStyles}>
                                        <CustomPopOver
                                          open={true}
                                          anchorEl={anchorEl}
                                          listItems={formMessageConversationActions(
                                            message,
                                            t
                                          )}
                                          position="bottom-end"
                                          handleClose={() => {
                                            setMessageActionId(null);
                                            setAnchorEl(null);
                                          }}
                                          handleListItemClick={(item: any) => {
                                            handleMessageAction(
                                              message,
                                              index,
                                              item
                                            );
                                          }}
                                          enablePortal={true}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {message.body && (
                                    <div className="body-content">
                                      {message.body}
                                    </div>
                                  )}
                                  {message?.messages_media?.map(
                                    (media: any, index1: number) => (
                                      <div
                                        key={index1}
                                        className={
                                          media?.transcribe === null
                                            ? [
                                                'margin-body',
                                                message.archived
                                                  ? 'archive-body'
                                                  : ''
                                              ].join(' ')
                                            : ''
                                        }>
                                        <div
                                          key={media?.id}
                                          onMouseEnter={(e: any) => {
                                            setMediaKey(media?.id);
                                          }}
                                          onMouseLeave={e => {
                                            setMediaKey(-1);
                                          }}
                                          className={[
                                            media?.transcribe === null
                                              ? ''
                                              : 'transcribe-body',
                                            message.archived
                                              ? 'archive-body'
                                              : ''
                                          ].join(' ')}>
                                          {media?.transcribe !== null ? (
                                            <div className="transcribed-message-body-text">
                                              {media?.transcribe
                                                ?.transcribe_text !== ''
                                                ? t(
                                                    'INCOMING_SMS.CONVERSATION.TRANSCRIPTION_TEXT'
                                                  )
                                                : t(
                                                    'INCOMING_SMS.CONVERSATION.NON_TRANSCRIPTION_TEXT'
                                                  )}
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                          {
                                            <ViewMediaFile
                                              id={media?.id}
                                              mediaKey={mediaKey}
                                              clinicGroupId={
                                                message?.clinic_group_id
                                              }
                                              clinicId={message?.clinic_id}
                                              fileId={media?.file_id}
                                              extension={media?.file?.extension}
                                              mimeType={media?.file?.mime_type}
                                              fileName={media?.file?.name}
                                              mainClass={
                                                'transcribed-media-item'
                                              }
                                              transcribe={media?.transcribe}
                                            />
                                          }
                                          {media?.transcribe === null
                                            ? ''
                                            : media?.transcribe
                                                ?.transcribe_text && (
                                                <div className="transcribe-text">
                                                  {
                                                    media?.transcribe
                                                      ?.transcribe_text
                                                  }
                                                </div>
                                              )}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="message-bottom-wrapper">
                              <div className="sent-by">
                                {message.archived ? (
                                  <div className="archive">
                                    <span className="label">
                                      {t('INCOMING_SMS.CONVERSATION.ARCHIVED')}
                                    </span>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {message.app_status &&
                                message.direction === SMS_DIRECTION.OUTBOUND ? (
                                  <div className="sent-status-wrap">
                                    <span className="sent-status sent-by-text">
                                      {t('INCOMING_SMS.CONVERSATION.SENT_BY')}{' '}
                                      <span style={{fontWeight: 700}}>
                                        {getSender(message)}
                                      </span>
                                    </span>
                                    <span style={{fontSize: '1rem'}}>
                                      &bull;
                                    </span>
                                    <span className="sent-status sent-by-icon">
                                      {renderNotificationStatusIcon(
                                        message.app_status,
                                        message.failed_reason
                                      )}
                                    </span>
                                    <span
                                      className="sent-status refresh-msg sent-by-icon"
                                      onClick={() =>
                                        refreshMessageStatus(message.id)
                                      }>
                                      {renderRefresh(message.app_status)}
                                    </span>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {message.direction === SMS_DIRECTION.INBOUND &&
                                !message.archived ? (
                                  <div className="sent-status-wrap">
                                    <div className="assign-wrap">
                                      {message?.assign_user_details ? (
                                        <div className="assigned">
                                          {t(
                                            'INCOMING_SMS.CONVERSATION.ASSIGNED_TO'
                                          )}{' '}
                                          <span style={{fontWeight: 700}}>
                                            {HelperUtils.formFullName(
                                              message?.assign_user_details
                                                ?.first_name,
                                              message?.assign_user_details
                                                ?.last_name
                                            )}
                                          </span>
                                        </div>
                                      ) : (
                                        <Trans
                                          i18nKey={
                                            'INCOMING_SMS.CONVERSATION.NOT_ASSIGNED'
                                          }
                                          components={[
                                            <span
                                              className="assigned"
                                              key={'X'}
                                            />
                                          ]}
                                        />
                                      )}
                                      <span
                                        className={[
                                          'assign-to-button sent-status',
                                          classes.customPopOverStyles
                                        ].join(' ')}>
                                        <MessagesAssignedUsers
                                          messageDetails={message}
                                          refreshConversation={(
                                            selectedMessageId: any,
                                            messageDetails: any,
                                            userDetails: any
                                          ) => {
                                            refreshMessageStatus(
                                              selectedMessageId
                                            );
                                          }}
                                          groupUsers={groupUsers}
                                        />
                                      </span>
                                      {/* Showing mark as done as primary action at the messages bottom */}
                                      {message?.event_type_status !==
                                        ReminderWorkFlowStatusTypes.COMPLETED && (
                                        <div
                                          className={[
                                            'link-style',
                                            ClinicClasses.actionTypeLabel
                                          ].join(' ')}
                                          onClick={() => {
                                            handleOpenMarkAsDoneDialog({
                                              clinicGroupId:
                                                message?.clinic_group_id,
                                              clinicId: message?.clinic_id,
                                              messageId: message?.id,
                                              notes: message?.notes
                                            });
                                          }}>
                                          {t(
                                            'MESSAGE_CONVERSATION_ACTIONS.MARK_AS_DONE'
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                              <div className="message-date-time">
                                {HelperUtils.formatDisplayDateTime(
                                  message.sms_sent_at || message.created_at
                                )}
                              </div>
                            </div>
                            {message.direction === SMS_DIRECTION.INBOUND &&
                              message.notes && (
                                <div className="message-notes-wrap">
                                  <p className="message-notes-label">
                                    {t('INCOMING_SMS.CONVERSATION.NOTES')}
                                  </p>
                                  <p className="message-notes-value">
                                    {message.notes}
                                  </p>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            {!isLoadingConversation && messages.length === 0 && (
              <div className="no-message-text">
                {t('INCOMING_SMS.CONVERSATION.NO_MESSAGES')}
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
        )}

        {/* CUSTOM SELECTION DROPDOWN */}
      </Typography>
      <div className={classes.dropDownMainViewParent}>
        <div className={classes.dropDownMainView}>
          <div className={classes.dropDownInfo}>
            {t('DUE_INVOICES.CUSTOM_MESSAGES.DROP_DOWN_INFO_TEXT')}
          </div>
          {renderCustomTemplateDropDown()}
        </div>
        <div className="conversation-dialog-actions">
          {isAllowSendMessage ? (
            <div className="conversations-respond-wrapper">
              <div className="respond-wrapper">
                <div className="textarea-wrapper">
                  <Controller
                    id="responseMessage"
                    rows={4}
                    placeholder={t(
                      'INCOMING_SMS.CONVERSATION.RESPOND_PLACEHOLDER'
                    )}
                    className="custom-textarea"
                    disabled={isSendingMessage}
                    as={TextareaAutosize}
                    control={control}
                    name={'responseMessage'}
                    defaultValue={''}
                  />
                </div>
                {/* <div className="button-wrapper"> */}

                <div className="action-wrapper">
                  <div className="send-button-wrap">
                    <Tooltip
                      title={`${t('INCOMING_SMS.CONVERSATION.SEND_TOOLTIP')}`}
                      classes={tooltipClasses}
                      placement="top">
                      <Button
                        data-test-id="pcl-payments-sendMessageButton"
                        variant={'contained'}
                        onClick={() => respond(selectedClinicId?.ClinicId?.[0])}
                        disabled={isSendingMessage}
                        color="primary"
                        className="send-button"
                        type={'submit'}>
                        <SendIcon />
                      </Button>
                    </Tooltip>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      {markAsDoneDialogState.isOpen && (
        <MarkAsDoneDialog
          open={markAsDoneDialogState.isOpen}
          onClose={handleCloseMarkAsDoneDialog}
          clinicGroupId={markAsDoneDialogState.clinicGroupId as number}
          clinicId={markAsDoneDialogState.clinicId as number}
          messageId={markAsDoneDialogState.messageId as number}
          notes={markAsDoneDialogState.notes as string}
        />
      )}
    </div>
  );
};

export default MessagesConversation;
